export class PagingModel
{
    pageNumber: number;
    pageSize: number;    
}